import script from "./MenuAtividadesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuAtividadesComponent.vue?vue&type=script&setup=true&lang=js"

import "./MenuAtividadesComponent.vue?vue&type=style&index=0&id=613ed0be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-613ed0be"]])

export default __exports__